import {
  HAS_EXTEND_PROCESS_KEY,
  LOGINTIME_KEY,
  RND_KEY,
  SESSION,
  UIN,
} from '../constants/user'
import { SKILLHUB_LEAD_FLAG, SKILLHUB_LEAD_VALUE } from '../constants/skillhubLeadAuth'

const UC_EXTRA_KEYS = ['session3'] as const

function removeItems(keys: readonly string[]): void {
  try {
    for (const k of keys) localStorage.removeItem(k)
  } catch {
    /* ignore */
  }
}

export function hasUcSession(): boolean {
  try {
    return !!(
      localStorage.getItem(SESSION) &&
      localStorage.getItem(RND_KEY) &&
      localStorage.getItem(UIN)
    )
  } catch {
    return false
  }
}

/** 仅判断 localStorage 是否存在 uin（LoginWeb 即使走 lead 分支也会下发 uin，用于 apiKey 接口 X-uin 鉴权）。 */
export function hasUinStored(): boolean {
  try {
    const uin = localStorage.getItem(UIN)
    return uin !== null && uin !== '' && uin !== '0'
  } catch {
    return false
  }
}

export function hasSkillhubLeadAuth(): boolean {
  try {
    return (
      localStorage.getItem(SKILLHUB_LEAD_FLAG) === '1' &&
      !!localStorage.getItem(SKILLHUB_LEAD_VALUE)?.trim()
    )
  } catch {
    return false
  }
}

export function setSkillhubLeadAuth(areaCode: string, phone: string): void {
  const v = `${areaCode}${phone}`.trim()
  if (!v) return
  try {
    localStorage.setItem(SKILLHUB_LEAD_FLAG, '1')
    localStorage.setItem(SKILLHUB_LEAD_VALUE, v)
  } catch {
    /* ignore */
  }
}

export function clearSkillhubLeadAuth(): void {
  removeItems([SKILLHUB_LEAD_FLAG, SKILLHUB_LEAD_VALUE])
}

/**
 * 与 @/services/authApi clearUcSessionLocal 的 UC 键集一致，供包内/拦截器与 App 共用。
 */
export function clearUcSessionStorageKeys(): void {
  removeItems([SESSION, UIN, RND_KEY, LOGINTIME_KEY, HAS_EXTEND_PROCESS_KEY, ...UC_EXTRA_KEYS])
}

export function clearUcAndSkillhubLeadStorage(): void {
  clearUcSessionStorageKeys()
  clearSkillhubLeadAuth()
}
